import zhCnConfig from './zh-cn/main.json';
import enConfig from './en/main.json';
import zhHkConfig from './zh-hk/main.json';
import { getLang, getLangValue } from '@tencent/wphk-components-common/utils/lang';
let langConfig = zhHkConfig; // 默认语言
/**
 * 语言map
 */
const langMap = {
    'zh-hk': zhHkConfig,
    'zh-cn': zhCnConfig,
    en: enConfig,
};
/**
 * 初始化语言
 * @param lang
 */
export function initLang() {
    langConfig = langMap[getLang()];
}
export function i18n(key, data) {
    return getLangValue(key, langConfig, data);
}
initLang();
